export default __webpack_public_path__ + "static/media/PR.STREAK.THREE_WEEKS.e02445be.jpg";